// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "i/js/" + "about" + "-legacy." + "ca759fc7" + ".js";
};